import { useMemo } from "react";
import { useServices } from "@/services-context";
import styles from "./fix-brand.module.scss";
import { Icon } from "@/elements-react/fix-icon";
import { LayoutStyleTypes } from "@/util-react/layout";
import { CUSTOMER_CHANNEL_LISTENER_NAME } from "@/services/customer-channel.ts";
import classNames from "classnames";
import {useEffect, useState} from "preact/hooks";
import {IconResolver} from "icon-resolver";

export type FixBrandProps = {
  type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;
  iconWidth?: number;
  className?: string;
};

const checkIsSvg = (url: string) => /.*svg/.test(url);

export const FixBrand = ({ type = LayoutStyleTypes.TYPE_LG, iconWidth = 100, className }: FixBrandProps) => {
  const services = useServices([CUSTOMER_CHANNEL_LISTENER_NAME]);
  const logoUrl = services.customerChannel.logoUrl!;

  return (
    <div className={classNames(styles.root, styles[type])}>
      <BrandLogo url={logoUrl} width={iconWidth} className={className} cacheId={services.customerChannel?.channelOptions?.id} />
    </div>
  );
};

const BrandLogo = (props: { url: string, width: number, className?: string, cacheId?: string }) => {
  const { url, width } = props;

  const svg = IconResolver.instance.getResourse(props.url, 'logo');
  const isSvg = svg?.trim().startsWith("<svg");

  if (isSvg) {
    return (
        <span
            className={classNames(styles.icon, props.className)}
            dangerouslySetInnerHTML={{ __html: svg }}
        />
    );
  }

  return <img src={url} alt="logo" className={styles.icon} height={17} />;
};
